import { useState } from 'react';
import type { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../hooks/use-auth';
import { Login } from '../containers/login';
import { AccessDenied } from '../containers/access-denied';

interface RoleBasedGuardProps {
  children: ReactNode;
  roles: string[];
}

export const RoleBasedGuard: FC<RoleBasedGuardProps> = (props) => {
  const { children, roles } = props;
  const auth = useAuth();
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  // check if user is authenticated or not
  if (!auth.isAuthenticated) {
    if (location.pathname !== requestedLocation) {
      setRequestedLocation(location.pathname);
    }

    return (
      <Login />
    );
  }

  // if user is authenticated & is allowed to access the route
  if (auth.isAuthenticated && (roles.includes(auth.user.scope))) {
    return <>{children}</>;
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return (
    <AccessDenied />
  );
};

RoleBasedGuard.propTypes = {
  children: PropTypes.node,
  roles: PropTypes.array
};
